import { isObject } from '../../utils/general';
import {
  FormatsApiResponsesError,
  ValidationExceptionError,
} from '../types/ApiErrorPayload';

/** Narrows to any payload carrying a field-level `errors` map (Shape D or E). */
export const hasErrorsMap = (
  payload: unknown,
): payload is ValidationExceptionError | FormatsApiResponsesError =>
  isObject(payload) && isObject(payload.errors);
